// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayGame_container__1cPQZ","grid":"PlayGame_grid__bUjgI","message":"PlayGame_message__itQ4w","success":"PlayGame_success__2KDCx"};